import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { Subject } from 'rxjs/internal/Subject';
import { STAFF_CUSTOMER_GROUP_ID, STORE_STAFF_CUSTOMER_GROUP_ID } from '../../../customer/groups/customer-groups';

@Injectable({
    providedIn: 'root'
})
export class InternalProductsService {
    update = new Subject<void>();

    private currentFlag!: boolean;

    constructor(private app: App) {
        this.currentFlag = this.internalProductsAvailable();
        this.app.customer.model.obs.data.pipe(takeUntilDestroyed()).subscribe(() => {
            const was = this.currentFlag;
            const current = this.internalProductsAvailable();

            if (was !== current) {
                this.currentFlag = current;
                this.update.next();
            }
        });
    }

    isProductAvailable(product: Product): boolean {
        return !this.isInternalProduct(product) || this.internalProductsAvailable();
    }

    filterProducts(products: Product[]): Product[] {
        return products.filter(product => this.isProductAvailable(product));
    }

    private isInternalProduct(product: Product): boolean {
        return !!(<IProductDataV2>product?.data)?.internal_only_product;
    }

    private internalProductsAvailable(): boolean {
        const groupId = this.app.customer.model.data?.group_id;

        return [STAFF_CUSTOMER_GROUP_ID, STORE_STAFF_CUSTOMER_GROUP_ID].indexOf(groupId) > -1;
    }
}
